module.exports = __webpack_public_path__ + "static/img/assicon.1dd5716.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assicon.png
// module id = 142
// module chunks = 1